import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Select from './Select';

function Inline(_ref) {
  var light = _ref.light,
      hover = _ref.hover,
      focus = _ref.focus,
      readOnly = _ref.readOnly,
      restProps = _objectWithoutPropertiesLoose(_ref, ["light", "hover", "focus", "readOnly"]);

  var pseudoStyles = readOnly ? {} : {
    backgroundColor: light ? 'light-0' : 'highlight'
  };

  if (hover || focus) {
    restProps = _objectSpread(_objectSpread({}, restProps), pseudoStyles);
  }

  return /*#__PURE__*/React.createElement(Select, _extends({
    inline: true,
    naked: true,
    paddingLeft: 0.5,
    marginHorizontal: -0.5,
    stroke: undefined,
    backgroundColor: "transparent",
    color: light ? 'light-9' : 'foreground',
    hover: pseudoStyles,
    focus: pseudoStyles,
    readOnly: readOnly
  }, restProps));
}

export default Inline;